const commonConverter = {
  latlng: (arr) => arr ? new AMap.LngLat(arr[0], arr[1]) : undefined
}

const upperCamelCase = (v) => v.replace(/(\-([a-z])|(^[a-z]))/g, (_, i) => i.toUpperCase())

export default {
  data() {
    return {
      ready:false,
      watchers: [],
      listeners: {}
    }
  },
  mounted() {
    this.$amap = this.$amap || this.$parent.$amap;
    if (this.$amap) {
      this.ready = true;
      this.register();
    } else {
      this.$on('ready', map => {
        this.$amap = map;
        this.ready = true;

        this.register();
      });
    }
  },
  methods: {
    // 属性修改函数 ， 默认顺序 $set[PropName] -> 组件.setOptions
    _getHandler(prop) {
      let p = upperCamelCase(prop)
      if (this[`$set${p}`]) {
        return this[`$set${p}`]
      }

      return this.$amapComponent[`set${p}`] || this.$amapComponent.setOptions;
    },
    register() {
      const res = this.$initComponent && this.$initComponent(this.convertProps());

      if (res) {
        if (res.then) res.then((instance) => this.registerRest(instance)); // promise
        else this.registerRest(res);
      }
    },
    registerRest(instance) {
      if (!this.$amapComponent && instance) this.$amapComponent = instance;
      this.regListeners();
      this.setPropWatchers();
    },

    //为地图组件注册事件
    regListeners() {
      if(!this.$amapComponent) return;
      let listeners = this.listeners
      Object.keys(this.$listeners).forEach(eventName => {
        let [type, act] = eventName.split('.')
        if (type == 'ready' || type == 'input') return
        if(type.startsWith('$')){
          if (act == 'once') {
            AMap.event.addListenerOnce(this.$amapComponent, type, this._commonEmit.bind(this))
          } else {
            if (!listeners[type]) listeners[type] = []
            let listener = AMap.event.addListener(this.$amapComponent, type, this._commonEmit.bind(this));
            listeners[type].push(listener)
          }
        }
        
      })
    },
    removeListener(type) {
      (this.listeners[type] || []).forEach(listener => {
        AMap.event.removeListener(listener)
      })
    },

    clearListeners() {
      Object.keys(this.listeners).map(eventName => {
        this.removeListener(eventName)
      })
    },

    _commonEmit(data) {
      this.$emit(data.type, data)
    },

    convertProps() {
      let props = {};
      // if (this.$amap) props.map = this.$amap;
      const propsData = this.$options.propsData;
      
      Object.keys(propsData).forEach( i => {
        props[i] = this.convertProp(i, propsData[i]);
      })

      return props
    },

    //将输入值转换为 可用的目标值
    convertProp(key, value) {
      
      // 1.内置转换函数
      if (this[`$conv${upperCamelCase(key)}`]) {
        return this[`$conv${upperCamelCase(key)}`].call(this, value);
      }
      // 2.如果已经在prop处指明转换类型(class) 则从通用转换器匹配
      else if (this.$options.props[key] && this.$options.props[key].class) {
        let type = this.$options.props[key].class;
        let converter = commonConverter[type];
        if (converter) {
          return converter(value);
        }
      }
      // 3.使用prop名匹配
      else {
        return commonConverter[key] ? commonConverter[key](value) : value;
      }
    },

    setPropWatchers() {
      Object.keys(this.$options.propsData).forEach(prop => {
        let oriProp = prop;
        let handle = this._getHandler(oriProp);
        if (!handle) return;

        const watch = this.$watch(prop, (nv) => {
          if (handle === this.$amapComponent.setOptions) {
            return handle.call(this.$amapComponent, {
              [oriProp]: this.convertProp(prop, nv)
            });
          } else {
            return handle.call(this.$amapComponent, this.convertProp(prop, nv));
          }
        });

        // collect watchers for destroyed
        this.watchers.push(watch);
      });
    },
  },
  destroyed() {
    this.clearListeners();
    if (!this.$amapComponent) return;

    this.$amapComponent.setMap && this.$amapComponent.setMap(null);
    this.$amapComponent.close && this.$amapComponent.close();
    this.watchers.forEach(item => item());
    this.watchers = [];
    this.listeners = {};
  },
};
